// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"W4-z"};